import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import { useMemo } from 'react'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function RouterOptionsPicklist({
  disabled = false,
  name = 'routerOptions',
  label = 'Router',
  routers = [],
  ...rest
}) {
  const options = useMemo(() => {
    const routerOptions = routers.map((router) => {
      return {
        label: router?.name,
        value: router?.id,
      }
    })
    return routerOptions
  }, [routers])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      items={options}
      loadingMessage="Checking routers..."
    />
  )
}
